import { render, staticRenderFns } from "./PunchPlates.vue?vue&type=template&id=2e8db994&scoped=true"
import script from "./PunchPlates.vue?vue&type=script&lang=js"
export * from "./PunchPlates.vue?vue&type=script&lang=js"
import style0 from "./PunchPlates.vue?vue&type=style&index=0&id=2e8db994&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8db994",
  null
  
)

export default component.exports